/* ==========================================================================
   claude 户型展示 floorplan — 交互
   三件事：
     1. 放大查看：编辑器截图 / 平面图在原页面用 <dialog> 放大，不跳转
        大图只在点击时才请求；Esc、关闭按钮、点遮罩都能关，焦点回到触发按钮
     2. 下载统计：点击下载按钮向 dataLayer 推送 claude_sample_download
     3. 编辑器视频：进入视口 40% 才按断点写入视频源并播放，离开暂停；
        播一次停在末帧给重播（或循环）；减少动效时不自动播；
        断点切换时换源，桌面 / 移动两条视频永远只下载一条
   无 JS 时：放大按钮无效果（图片仍在页面上可见），下载链接照常可用。
   ========================================================================== */

(function () {
  'use strict';

  var ATTR = 'fpInit';

  function initFloorplan(root) {
    if (!root || root.dataset[ATTR] === 'true') return;
    root.dataset[ATTR] = 'true';

    var dialog = root.querySelector('[data-fp-dialog]');
    var dbody = dialog ? dialog.querySelector('[data-fp-dbody]') : null;
    var dimg = null;
    var canModal = !!(dialog && typeof dialog.showModal === 'function');
    var lastTrigger = null;
    var prevOverflow = '';

    function openZoom(btn) {
      if (!canModal || !dbody) return;
      lastTrigger = btn;
      dimg = document.createElement('img');
      dimg.className = dbody.getAttribute('data-fp-imgclass') || '';
      dimg.decoding = 'async';
      dimg.draggable = false;
      dbody.appendChild(dimg);
      dimg.src = btn.getAttribute('data-fp-src') || '';
      dimg.alt = btn.getAttribute('data-fp-alt') || '';
      var w = btn.getAttribute('data-fp-w'), h = btn.getAttribute('data-fp-h');
      if (w && h) { dimg.width = parseInt(w, 10); dimg.height = parseInt(h, 10); }
      prevOverflow = document.documentElement.style.overflow;
      document.documentElement.style.overflow = 'hidden';   /* 锁背景滚动 */
      dialog.showModal();
    }

    function closeZoom() {
      if (dialog && dialog.open) dialog.close();
    }

    /* 无论哪种方式关闭（按钮 / Esc / 遮罩），都走 close 事件统一收尾 */
    var onClose = function () {
      document.documentElement.style.overflow = prevOverflow;
      if (dimg && dimg.parentNode) dimg.parentNode.removeChild(dimg);
      dimg = null;
      if (lastTrigger && lastTrigger.focus) {
        try { lastTrigger.focus({ preventScroll: true }); } catch (err) { lastTrigger.focus(); }
      }
      lastTrigger = null;
    };

    /* 点在 dialog 自身（即图片以外的留白 / 遮罩）时关闭 */
    var onDialogClick = function (e) {
      if (e.target === dialog) closeZoom();
    };

    function track(a) {
      var payload = {
        event: 'claude_sample_download',
        sample_id: a.getAttribute('data-fp-dl') || '',
        sample_label: a.getAttribute('data-fp-dl-label') || '',
        sample_url: a.getAttribute('href') || '',
        page_path: window.location.pathname
      };
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push(payload);
    }

    var onClick = function (e) {
      if (!e.target.closest) return;
      var z = e.target.closest('[data-fp-zoom]');
      if (z && root.contains(z)) { e.preventDefault(); openZoom(z); return; }
      if (e.target.closest('[data-fp-dclose]')) { e.preventDefault(); closeZoom(); return; }
      var d = e.target.closest('[data-fp-dl]');
      if (d && root.contains(d)) track(d);   /* 不拦截，让浏览器照常下载 */
    };
    root.addEventListener('click', onClick);

    if (dialog) {
      dialog.addEventListener('close', onClose);
      dialog.addEventListener('click', onDialogClick);
    }

    /* 不支持 <dialog> 的旧浏览器：放大按钮隐藏，避免点了没反应 */
    if (!canModal) {
      var zs = root.querySelectorAll('[data-fp-zoom]');
      for (var i = 0; i < zs.length; i++) {
        if (zs[i].tagName === 'BUTTON' && !zs[i].querySelector('span')) zs[i].hidden = true;
      }
    }


    /* ---------- 编辑器视频 ---------- */
    var vbox = root.querySelector('[data-fp-vbox]');
    var video = vbox ? vbox.querySelector('[data-fp-video]') : null;
    /* 按钮可能在画面内，也可能在画面下方：从 figure 范围找，状态同时写到 figure 上 */
    var vfig = vbox ? (vbox.closest('[data-fp-vfig]') || vbox) : null;
    var vbtn = vfig ? vfig.querySelector('[data-fp-vtoggle]') : null;
    var mq = window.matchMedia('(max-width: 749px)');
    var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var vio = null, inView = false, userPaused = false, curSrc = '';

    function vset(state) {
      if (!vbox) return;
      vbox.setAttribute('data-fp-vstate', state);
      if (vfig && vfig !== vbox) vfig.setAttribute('data-fp-vstate', state);
      if (!vbtn) return;
      var key = state === 'playing' ? 'data-fp-l-pause' : (state === 'ended' ? 'data-fp-l-replay' : 'data-fp-l-play');
      var label = vbtn.getAttribute(key);
      if (label) vbtn.setAttribute('aria-label', label);
    }

    function wantedSrc() {
      if (!vbox) return '';
      return vbox.getAttribute(mq.matches ? 'data-fp-vsrc-m' : 'data-fp-vsrc-d') || '';
    }

    /* 只在需要时写入 src：进入视口才开始下载 */
    function ensureSrc() {
      var want = wantedSrc();
      if (!want) { vset('off'); return false; }
      if (want !== curSrc) {
        curSrc = want;
        vbox.removeAttribute('data-fp-vshown');
        video.src = want;
        video.load();
        vset('loading');
      } else if (vbox.getAttribute('data-fp-vstate') === 'off') {
        vset('paused');
      }
      return true;
    }

    function vplay() {
      if (!video || !ensureSrc()) return;
      if (video.ended) { try { video.currentTime = 0; } catch (err) {} }
      var pr = video.play();
      if (pr && pr.catch) pr.catch(function () { vset('paused'); });
    }

    function vpause() { if (video && !video.paused) video.pause(); }

    function onPlaying() { vbox.setAttribute('data-fp-vshown', 'true'); vset('playing'); }
    function onPause() { if (!video.ended) vset('paused'); }
    function onEnded() { vset('ended'); }
    function onLoaded() { vbox.setAttribute('data-fp-vshown', 'true'); }

    function onToggle(e) {
      e.preventDefault();
      if (!video) return;
      if (!video.paused && !video.ended) { userPaused = true; vpause(); }
      else { userPaused = false; vplay(); }
    }

    /* 断点变化：源不同就换，保持原来的播放意愿 */
    var onMq = function () {
      if (!video) return;
      var want = wantedSrc();
      if (!want) { vpause(); video.removeAttribute('src'); video.load(); curSrc = ''; vset('off'); return; }
      if (want === curSrc) return;
      curSrc = '';
      if (inView && !reduce && !userPaused) vplay();
      else vset('idle');
    };

    if (video) {
      if (!wantedSrc()) vset('off');
      video.addEventListener('playing', onPlaying);
      video.addEventListener('pause', onPause);
      video.addEventListener('ended', onEnded);
      video.addEventListener('loadeddata', onLoaded);
      if (vbtn) vbtn.addEventListener('click', onToggle);
      if (mq.addEventListener) mq.addEventListener('change', onMq);
      else if (mq.addListener) mq.addListener(onMq);

      if ('IntersectionObserver' in window) {
        vio = new IntersectionObserver(function (es) {
          for (var k = 0; k < es.length; k++) {
            inView = es[k].isIntersecting;
            if (inView) {
              /* 减少动效：只准备好封面与按钮，不自动播；播完的不自动重播 */
              if (!reduce && !userPaused && !video.ended) vplay();
            } else {
              vpause();
            }
          }
        }, { threshold: 0.4 });
        vio.observe(vbox);
      }
    }

    root._fpTeardown = function () {
      closeZoom();
      root.removeEventListener('click', onClick);
      if (video) {
        if (vio) vio.disconnect();
        vpause();
        video.removeEventListener('playing', onPlaying);
        video.removeEventListener('pause', onPause);
        video.removeEventListener('ended', onEnded);
        video.removeEventListener('loadeddata', onLoaded);
        if (vbtn) vbtn.removeEventListener('click', onToggle);
        if (mq.removeEventListener) mq.removeEventListener('change', onMq);
        else if (mq.removeListener) mq.removeListener(onMq);
        video.removeAttribute('src');
        video.load();
      }
      if (dialog) {
        dialog.removeEventListener('close', onClose);
        dialog.removeEventListener('click', onDialogClick);
      }
      delete root.dataset[ATTR];
      delete root._fpTeardown;
    };
  }

  function initAll(scope) {
    var roots = (scope || document).querySelectorAll('[data-fp-root]');
    for (var i = 0; i < roots.length; i++) initFloorplan(roots[i]);
  }

  function rootOf(t) { return t && t.querySelector ? t.querySelector('[data-fp-root]') : null; }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(); });
  } else { initAll(); }

  document.addEventListener('shopify:section:load', function (e) {
    var r = rootOf(e.target); if (r) initFloorplan(r);
  });
  document.addEventListener('shopify:section:unload', function (e) {
    var r = rootOf(e.target); if (r && r._fpTeardown) r._fpTeardown();
  });
  document.addEventListener('shopify:section:reorder', function (e) {
    var r = rootOf(e.target); if (r) { if (r._fpTeardown) r._fpTeardown(); initFloorplan(r); }
  });
})();